window.initPersonalization = function () {
    console.info('initPersonalization');
};

window.PersonalizationModal = {
    modalSelector: '#modalPersonalization',
    announcerSelector: '#js-pn-modal-announcer',
    closeBtnSelector: '.js-pn-modal-close',
    lastFocusedElement: null,

    init() {
        if ($(this.modalSelector).length > 0 && $(this.announcerSelector).length > 0) {
            this.show();
        }
    },

    show() {
        if (!$(this.modalSelector).length || !$(this.announcerSelector).length) return;
        let annuncerText = $(this.announcerSelector).attr('data-text');
        this.lastFocusedElement = document.activeElement;

        $(this.modalSelector)
            .off('show.bs.modal shown.bs.modal hide.bs.modal hidden.bs.modal')
            .on('show.bs.modal', () => {
                $(this.modalSelector)[0].focus();
            })
            .on('shown.bs.modal', () => {
                $(this.modalSelector).focus();
            })
            .on('hide.bs.modal', () => {
                if ($(document.activeElement).closest(this.modalSelector).length > 0) {
                    document.activeElement.blur();
                }
            })
            .on('hidden.bs.modal', () => {
                if (this.lastFocusedElement) {
                    this.lastFocusedElement.focus();
                }
            });

        $(this.modalSelector).modal('show');
        $(this.announcerSelector).text(annuncerText);
    }
};

window.openAccessibleModal = function(modalId, announcementText = 'Attenzione! È apparso un messaggio importante.') {
    const modal = document.querySelector(modalId);
    if (!modal) return;
  
    let liveRegion = document.getElementById('liveRegionForModal');
    if (!liveRegion) {
        liveRegion = document.createElement('div');
        liveRegion.id = 'liveRegionForModal';
        liveRegion.setAttribute('aria-live', 'polite');
        liveRegion.setAttribute('aria-atomic', 'true');
        liveRegion.classList.add('sr-only');
        document.body.appendChild(liveRegion);
    }
  
    liveRegion.textContent = '';
    setTimeout(() => {
        liveRegion.textContent = announcementText;
    }, 100);
  
    const lastFocusedElement = document.activeElement;
  
    $(modalId)
        .off('shown.bs.modal hidden.bs.modal')
        .on('shown.bs.modal', function () {
            modal.focus();
        })
        .on('hidden.bs.modal', function () {
            if (lastFocusedElement && typeof lastFocusedElement.focus === 'function') {
                lastFocusedElement.focus();
            }
    });
  
    $(modalId).modal('show');
};

window.personalizationAlertMessage = (timing = 10000, $class) => {
    let timeout = timing;

    const $alert = $('.js-pn-alert');
    const $alertMessage = $('.js-pn-alert-message');

    let lastFocusedElement = null;

    // Save last focused element (keyboard users only)
    if (!$('body').hasClass('using-mouse') && !$(document.activeElement).closest('.js-overlay, .modal, .cc-overlay, .cc-alert').length) {
        lastFocusedElement = document.activeElement;
    }

    // Show the alert and make it accessible
    $alert
        .removeClass('cc-active') // reset state
        .addClass($class)
        .addClass('cc-active')
        .attr('aria-hidden', 'false')
        .attr('tabindex', '0');

    const hideAlert = () => {
        $alert
            .removeClass($class)
            .removeClass('cc-active')
            .attr('aria-hidden', 'true')
            .attr('tabindex', '-1');
    };

    setTimeout(hideAlert, timeout);
};
